import { Component } from '@angular/core';
import {
  CorporateHolderModel,
  HolderModelBase,
  IndividualHolderModel,
  SecurityRegistryRecord
} from "@models/shares/security-registry-record";
import { ICellRendererParams } from "ag-grid-community";
import { ICellRendererAngularComp } from "ag-grid-angular";

export interface IHolderWithPendingChangesCellRendererParams<T> extends ICellRendererParams<T> {
  pendingButtonState: boolean;
}

@Component({
  selector: 'app-ag-holder-number-of-shares',
  standalone: true,
  templateUrl: 'ag-holder-number-of-shares.component.html',
  styleUrl: 'ag-holder-number-of-shares.component.scss'
})
export class AgHolderNumberOfSharesComponent implements ICellRendererAngularComp {
  pendingButtonState = false;
  numberOfShares = 0;
  previousNumberOfShares = 0;

  CorporateHolderModel = CorporateHolderModel;
  IndividualHolderModel = IndividualHolderModel;

  agInit(params: IHolderWithPendingChangesCellRendererParams<SecurityRegistryRecord>): void {
    this.updateCell(params);
  }

  refresh(params: IHolderWithPendingChangesCellRendererParams<SecurityRegistryRecord>): boolean {
    return this.updateCell(params);
  }

  updateCell(params: IHolderWithPendingChangesCellRendererParams<SecurityRegistryRecord>): boolean {
    this.pendingButtonState = params.pendingButtonState ?? false;
    this.numberOfShares = params.data?.number ?? 0;
    this.previousNumberOfShares = params.data?.previousNumber ?? 0;
    return true;
  }
}
